import React, { useEffect } from 'react';
import ProtectedRoute from './ProtectedRoute';
import ThankYou from '../pages/landing/Home/ThankYou';
import Dashboardv2 from '../pages/Dashboardv2';
import EmployeesKpi from "../pages/managementDashboard/EmployeesKpi";
import BottleNeckReport from "../pages/managementDashboard/BottleNeckReport";
import MyTaskWorkflow from '../pages/myTask/MyTaskWorkflow';
import MyWorkflowTaskDetails from '../pages/myTask/MyWorkflowTaskDetails';
import MyChecklistTask from "../pages/myTask/MyChecklistTask";
import MyTaskTrackerList from '../pages/myTask/MyTaskTrackerList';
import TaskManagerWorkflow from '../pages/taskManager/workflow/TaskManagerWorkflow';
import NewWorkflowTemplate from '../pages/taskManager/workflow/NewWorkflowTemplate';
import NewWorkflowTask from '../pages/taskManager/workflow/NewWorkflowTask';
import EditWorkflowTask from '../pages/taskManager/workflow/EditWorkflowTask';
import TaskManagerChecksheet from '../pages/taskManager/checksheet/TaskManagerChecksheet';
import AddNewChecksheet from '../pages/taskManager/checksheet/AddNewChecksheet';
import DashboardFlow from '../pages/Dashboardv2-flow';
import DashboardCalendar from '../pages/Dashboardv2-calendar';

import AdminLogin from '../pages/admin/AdminLogin';
import ResetPassword from '../pages/admin/ResetAdminPassword';
import ForgotAdminPassword from '../pages/admin/ForgotAdminPassword';
import VerifyAdminOtp from '../pages/admin/VerifyAdminOtp'
// import Module from '../pages/admin/Module';
// import Plan from '../pages/admin/Plan'

import UserAdminLogin from '../pages/auth/UserAdminLogin';
import AdminPlan from '../pages/admin/AdminPlan';
import AdminModule from '../pages/admin/AdminModule';
import AdminCompany from '../pages/admin/AdminCompany';
import UpgradePlan from '../pages/LandingCart/UpgradeCartPage';
import LandingCartIndex from '../pages/LandingCart/LandingCartIndex';

import Login from '../pages/auth/Login';
import EmailRegisteration from '../pages/auth/EmailRegisteration';
import VerifyOtp from '../pages/auth/VerifyOtp';
import SetPassword from '../pages/auth/SetPassword';
import Register from '../pages/auth/Register';
import UserDashboardIndex from '../pages/UserDashboard/UserDashboardIndex';
import PurchasePage from '../pages/LandingCart/PurchasePage';
import Page404 from '../pages/PageNotFound/Page404';
import PurchaseThankYou from '../pages/landing/Home/PurchaseThankYou';
import { UserAuth } from '../pages/auth/Auth';
import RedirectIfLoggedIn from './RedirectIfLoggedIn';
import LandingModuleUpgradeIndex from '../pages/LandingModuleUpgrade/LandingModuleUpgradeIndex';
import LandingModuleRenewIndex from '../pages/LandingModuleRenew/LandingModuleRenewIndex';
import LandingCartRenewIndex from '../pages/LandingCartRenew/LandingCartRenewIndex';


const LandingBusinessTaskAutomationSoftware = React.lazy(() => import('../pages/BusinessTaskAutomationSoftware/LandingBusinessTaskAutomationSoftware'));
const LandingBusinessManagementSoftware = React.lazy(() => import('../pages/BusinessManagementSoftware/LandingBusinessManagementSoftware'));
const LandingAutomateBusinessTasks = React.lazy(() => import('../pages/AutomateBusinessTasks/LandingAutomateBusinessTasks'));
const LandingContactUsIndex = React.lazy(() => import('../pages/ContactUs/LandingContactUsIndex'));
const LandingRefundPolicyIndex = React.lazy(() => import('../pages/RefundPolicy/LandingRefundPolicyIndex'));
const LandingCancellationPolicyIndex = React.lazy(() => import('../pages/CancellationPolicy/LandingCancellationPolicyIndex'));
const LandingPricingPolicyIndex = React.lazy(() => import('../pages/PricingPolicy/LandingPricingPolicyIndex'));
const LandingPrivacyPolicyIndex = React.lazy(() => import('../pages/PrivacyPolicy/LandingPrivacyPolicyIndex'));
const LandingTermsConditionIndex = React.lazy(() => import('../pages/TermsCondition/LandingTermsConditionIndex'));
const LandingModuleIndex = React.lazy(() => import('../pages/LandingModule/LandingModuleIndex'));



const LandingMain = React.lazy(() => import('../LandingMain'));
const ForgotPassword = React.lazy(() => import('../pages/auth/ForgotPassword'));
const ResetPasswordd = React.lazy(() => import('../pages/auth/ResetPassword'));

//all admin panel component call
const Dashboard = React.lazy(() => import('../pages/Dashboard'));

const { createBrowserRouter, Navigate } = require("react-router-dom");
// if (isAuthenticated && (window.location.pathname === '/login' || window.location.pathname === '/admin/login')) {
// window.history.go(0);
// }

const router = createBrowserRouter(

    [
        {
            path: '/',
            element: <LandingMain />,
            index: true
        },
        {
            path: '/email-registration',
            element: <EmailRegisteration />,
        },
        {
            path: '/login',
            element: (
                <RedirectIfLoggedIn redirectTo="/dashboard">
                    <Login />
                </RedirectIfLoggedIn>
            ),

        },
        {
            path: '/admin/login',
            element: <AdminLogin />
        },
        {
            path: '/admin-login',
            element: <UserAdminLogin />,
        },
        {
            path: '/verify-otp',
            element: <VerifyOtp />,
        },
        {
            path: '/admin/verify-otp',
            element: <VerifyAdminOtp />,
        },
        {
            path: '/reset-password/:token',
            element: <ResetPasswordd />,
        },
        {
            path: '/set-password',
            element: <SetPassword />,
        },
        {
            path: '/forgot-password',
            element: <ForgotPassword />,
        },
        {
            path: '/admin/forgot-password',
            element: <ForgotAdminPassword />,
        },
        {
            path: '/register',
            element: (
                <RedirectIfLoggedIn redirectTo="/dashboard">
                    <Register />
                </RedirectIfLoggedIn>),
        },
        {
            path: '/thank-you',
            element: <ThankYou />,
        },
        {
            path: '/p-thank-you',
            element: <PurchaseThankYou />,
        },
        {
            path: '/modules',
            element: <LandingModuleIndex />,
        },

        {
            path: '/cart',
            element: <LandingCartIndex />,
        },
        {
            path: '/admin/reset-password',
            element: <ResetPassword />
        },

        {
            path: '/terms-condition',
            element: <LandingTermsConditionIndex />
        },
        {
            path: '/privacy-policy',
            element: <LandingPrivacyPolicyIndex />
        },
        {
            path: '/pricing-policy',
            element: <LandingPricingPolicyIndex />
        },
        {
            path: '/cancellation-policy',
            element: <LandingCancellationPolicyIndex />
        },
        {
            path: '/refund-policy',
            element: <LandingRefundPolicyIndex />
        },
        {
            path: '/contact-us',
            element: <LandingContactUsIndex />
        },
        {
            path: '/404',
            element: <Page404 />
        },
        {
            path: '/task-management-software',
            element: <LandingAutomateBusinessTasks />
        },
        {
            path: '/business-management-software',
            element: <LandingBusinessManagementSoftware />
        },
        {
            path: '/business-task-automation-software',
            element: <LandingBusinessTaskAutomationSoftware />
        },
        {
            path: '/purchase',
            element: <PurchasePage />
        },
        {
            path: '/modules-upgrade',
            element: <LandingModuleUpgradeIndex />,
        },
        {
            path: '/modules-renew',
            element: <LandingModuleRenewIndex />,
        },
        {
            element: <ProtectedRoute />,
            children: [
                {
                    path: '/dashboard',
                    element: <UserDashboardIndex />
                },


                {
                    path: '/upgrade',
                    element: <UpgradePlan />
                },
                {
                    path: '/cart-renew',
                    element: <LandingCartRenewIndex />
                },

                // {
                //     path: '/admin/dashboard/plan',
                //     element: <AdminPlan />
                // },
                // {
                //     path: '/admin/dashboard/company',
                //     element: <AdminCompany />
                // },
                // {
                //     path: '/admin/dashboard/module',
                //     element: <AdminModule />
                // },

            ]
        },
        {
            path: '*',
            // element: <p>404 Error - Nothing here...</p>
            element: <Page404 />

        }
    ]
);

export default router;